module.exports = __webpack_public_path__ + "assets/cross_icon.7f95492c.svg";